<template>
	<el-row id="RetrievePassword" type="flex" justify="center" align="middle">
		<el-col class="loginBox">
			<CloseIcon />
			<el-form ref="userForm" :model="userForm" status-icon label-width="60px" class="demo-ruleForm">
				<div class="titleIcon"><img src="../pic/titleIcon.png" /></div>
				<div class="title">找回密码</div>
				<el-form-item label="手机号" prop="mobile">
					<el-input v-model="userForm.mobile" placeholder="请输入手机号!" maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="验证码" prop="pass" style="position: relative;">
					<el-col :span="18">
						<el-input v-model="userForm.code" placeholder="验证码"></el-input>
					</el-col>
					<el-col :span="6">
						<el-button style="width: 100%;background: #B7A575;border-color:#B7A575 ;" type="primary" @click="getStadiumUser()">获取证码</el-button>
					</el-col>
				</el-form-item>
				<el-form-item>
					<el-button style="width: 100%;background: #B7A575;border-color:#B7A575 ;" type="primary" @click="submitForm('addForm')">确认</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<FooterMes/>
	</el-row>
</template>
<!--数据存贮交互，事件控制地区-->
<script>
	import CloseIcon from "@/components/CloseIcon"; // 关闭图标
	import FooterMes from "@/components/FooterMes.vue"; // 底部版权说明
	export default {
		name: 'RetrievePassword',
		components: {
			CloseIcon, //关闭图标
			FooterMes, //底部版权说明
		},
		data() {
			return {
				globalHttpUrl: this.httpUrl,
				userForm: {
					mobile: '',
					code: '',
				},
			}
		},
		methods: {
			submitForm: function() {
				var that = this;
				//  参数 mobile   code
				const sendData = {
					mobile: that.userForm.mobile,
					code: that.userForm.code
				};
				const sendUrl = that.httpUrl + "HXXCStadiumPCService/stadium/checkCode";
				that.axiosGet(sendUrl, sendData).then((res) => {
					const backData = res.data;
					console.log("res");
					console.log(res);
					if (backData.state == "0") {
						that.$message({
							message: "验证成功！",
							type: 'success',
							onClose: () => {
								that.$router.push({
									path: '/RegisterNewPassword'
								});
								sessionStorage.setItem("mobile", that.userForm.mobile);
							}
						});
					} else {
						that.$message({
							message: backData.message,
							type: 'warning'
						});
					}
				})
			},
			getCode() {
				const sendData = {
					mobile: this.userForm.mobile
				};
				const sendUrl =this.appHttpUrl+"HXXCServiceWeChat/sms/stadiumSend";
				this.axiosGet(sendUrl, sendData).then((response) => {
					console.log(response);
				}).catch((error) => {
					console.log(error);
				})
			},
			// 核对是否 是注册过得用户
			getStadiumUser() {
				let that = this;
				const sendData = {
					mobile: that.userForm.mobile
				};
				const sendUrl =that.httpUrl+"HXXCStadiumPCService/stadium/getStadiumUser";
				this.axiosPost(sendUrl, sendData).then((response) => {
					if(parseInt(response.data.state)==0){
						that.getCode();
					}else{
						that.$message({
							message: response.data.message,
							type: 'warning'
						});
					}
				}).catch((error) => {
					console.log(error);
				})
			},

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#RetrievePassword {
		width: 100%;
		height: 100%;
		background: url(../pic/loginBg.jpg) no-repeat;
		background-size: 100% 100%;
	}

	.loginBox {
		width: 33%;
		background: #fff;
		max-height: 400px;
		padding: 34px;
		border-radius: 4px;
		position: relative;
	}

	.demo-ruleForm {
		width: 100%;
	}

	.el-input__icon {
		position: absolute;
		right: 5px;
		top: 0;
	}

	.fontMes {
		width: 100%;
		text-align: right;
		color: #B7A575;
		font-size: 8px;
		margin-top: -11px;
		margin-bottom: 11px;

	}

	.title {
		color: #000000;
		font-weight: bold;
		font-size: 24px;
		margin-bottom: 29px;
		text-align: center;
	}

	.titleIcon {
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/views/RetrievePassword.vue